import { render, staticRenderFns } from "./PetunjukPenggunaan.vue?vue&type=template&id=2ccf25d0&"
import script from "./PetunjukPenggunaan.vue?vue&type=script&lang=js&"
export * from "./PetunjukPenggunaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports